import { createContext } from 'react';
import { LivePageableOfferStore } from '@gp/offer';

const defaultValue: LivePageableOfferStore = new LivePageableOfferStore();
export const LivePageStoreContext = createContext<LivePageableOfferStore>(defaultValue);